import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Table, Header, Link } from 'nallian-shared-ui/lib/components';
import { formatDateTime, formatRelativeTime } from 'nallian-shared-ui/lib/lib/dateTime';
import Language from '../../../../app/components/Language';
import PrincipalState from '../table/PrincipalState';

const PrincipalInformation = ({ principal }) => {
  const { t } = useTranslation();
  return (
    <Grid columns={2} stackable>
      <Grid.Column>
        <Header>{t('general')}</Header>
        <Table>
          {principal.organisation?.id && (
            <Table.Row>
              <Table.HeaderCell width={4}>{t('organisation')}</Table.HeaderCell>
              <Table.Cell>
                <Link to={`/organisations/${principal.organisation.id}`}>
                  {principal.organisation?.name || '-'}
                </Link>
              </Table.Cell>
            </Table.Row>
          )}
          <Table.Row>
            <Table.HeaderCell width={4}>{t('fullName')}</Table.HeaderCell>
            <Table.Cell>{principal.fullName}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('emailAddress')}</Table.HeaderCell>
            <Table.Cell>{principal.primaryEmailAddress || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('phoneNumber')}</Table.HeaderCell>
            <Table.Cell>{principal.primaryPhoneNumber || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('language')}</Table.HeaderCell>
            <Table.Cell>
              <Language value={principal.languageId} />
            </Table.Cell>
          </Table.Row>
        </Table>
        <Header>{t('metaData')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('createdOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(principal.createdOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(principal.createdOn)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('lastModifiedOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(principal.modifiedOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(principal.modifiedOn)}
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
      <Grid.Column>
        <Header>{t('location')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('timezone')}</Table.HeaderCell>
            <Table.Cell>{principal.timeZone || '-'}</Table.Cell>
          </Table.Row>
        </Table>
        <Header>{t('status')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('activeStatus')}</Table.HeaderCell>
            <Table.Cell>
              <PrincipalState value={principal.activeState} />
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
    </Grid>
  );
};

PrincipalInformation.propTypes = { principal: PropTypes.object };
PrincipalInformation.defaultProps = { principal: {} };

export default PrincipalInformation;
